<div
    class="container-fluid"
    *ngIf="transaction.id != undefined; else elseBlock"
>
    <div class="row">
        <!-- First Section -->
        <div class="col-md-12" #printContent>
            <div class="col-custom px-6 pt-5 existing" style="flex-basis: 65%">
                <div class="row ml-0 mb-1">
                    <ng-container
                        *ngIf="
                            invoiceData.data.schoolDetails.profileimg &&
                                showSchoolLogo;
                            else noSchoolLogo
                        "
                    >
                        <img
                            alt="app logo"
                            [src]="invoiceData.data.schoolDetails.profileimg"
                            class="shadow-4 border-circle flex-shrink-0"
                            style="width: 50px; height: 50px"
                            (error)="onSchoolLogoError()"
                        />
                    </ng-container>
                    <ng-template #noSchoolLogo>
                        <div
                            class="school-logo d-flex align-items-center justify-content-center border-circle shadow-4 flex-shrink-0"
                            [style.background-color]="
                                getBackgroundColor(schoolDetails.id ?? 0)
                            "
                            style="
                                width: 50px;
                                height: 50px;
                                font-size: 20px;
                                color: #fff;
                            "
                        >
                            {{
                                getInitials(
                                    invoiceData.data.schoolDetails?.name ?? ""
                                )
                            }}
                        </div>
                    </ng-template>
                    <div class="mx-3"></div>
                    <span class="app-name mt-2 text-lg font-semibold"
                        >{{ invoiceData.data.schoolDetails.name }}<br /><span
                            class="font-normal text-base"
                            >{{
                                invoiceData.data.schoolDetails.description
                            }}</span
                        >
                        <br /><span class="font-normal text-base"
                            >{{ this.addressDetails!.line }},{{
                                this.addressDetails!.city
                            }},{{ this.addressDetails!.state }},{{
                                this.addressDetails!.country
                            }},{{ this.addressDetails!.zipcode }}</span
                        ></span
                    >
                </div>
                <div
                    class="flex flex-column md:flex-row md:align-items-center md:justify-content-between my-3 gap-3"
                >
                    <div class="flex align-items-center">
                        <div class="ml-1 mr-2">
                            <span class="text-lg font-medium block"
                                >Payment for :</span
                            >
                        </div>
                        <ng-container
                            *ngFor="let student of transaction.students"
                        >
                            <img
                                *ngIf="student.profileimg; else noImageFound"
                                [src]="student.profileimg"
                                width="24"
                                height="24"
                                alt="profile"
                                class="shadow-4 border-circle flex-shrink-0"
                            />
                            <ng-template #noImageFound>
                                <!-- <a><img src="assets/layout/images/male.png" alt="Fallbackimage" width="24" height="24"
                                        class="shadow-4 border-circle flex-shrink-0" />
                                </a> -->
                                <!-- ##start of logic -->
                                <div
                                    class="shadow-4 border-circle flex-shrink-0 d-flex align-items-center justify-content-center"
                                    [style.background-color]="
                                        getBackgroundColor(student.id ?? 0)
                                    "
                                    style="
                                        width: 24px;
                                        height: 24px;
                                        font-size: 11px;
                                        color: #fff;
                                    "
                                >
                                    {{ getInitials(student.fullName || "") }}
                                </div>
                                <!-- ##end of logic -->
                            </ng-template>
                            <div class="ml-3">
                                <span class="text-m font-light"
                                    ><span class="font-normal">
                                        <b>{{ student.fullName }}</b></span
                                    >
                                </span>
                            </div>
                        </ng-container>
                    </div>
                </div>
                <div class="row mt-2">
                    <!-- Header Section -->
                    <div
                        class="col-12 flex p-2 border-round-top"
                        style="max-height: 27px"
                    >
                        <div class="pl-2 text-700">
                            Payment Date:
                            <span class="text-lg font-medium">
                                {{
                                    transaction.date
                                        ? (transaction.date | momentDate)
                                        : ""
                                }}
                            </span>
                        </div>
                    </div>

                    <div class="col-12 flex p-2 pt-1" style="max-height: 48px">
                        <div class="p-2 col-7 text-center md:text-left">
                            <span class="font-medium block text-lg"
                                >Description</span
                            >
                        </div>
                        <div class="p-2 col-2 text-center md:text-left">
                            <span class="font-medium block text-lg">Mode</span>
                        </div>
                        <div class="p-2 col-3 text-center md:text-right">
                            <span class="font-medium block text-lg"
                                >Amount</span
                            >
                        </div>
                    </div>

                    <div class="col-12 flex p-2" style="max-height: 48px">
                        <div class="p-2 col-7 text-center md:text-left">
                            <span class="text-lg font-medium block">{{
                                transaction.description
                            }}</span>
                        </div>
                        <div class="p-2 col-2 text-center md:text-left">
                            <span class="text-lg font-medium block">{{
                                transaction.paymentMode
                            }}</span>
                        </div>
                        <div class="p-2 col-3 text-center md:text-right">
                            <span class="text-lg block"
                                >${{ transaction.amount | number:'1.2-2'}}</span
                            >
                        </div>
                    </div>
                    <div
                        class="col-12 flex p-2 border-round-bottom"
                        style="max-height: 48px;padding: 10px !important; background : linear-gradient(to right, rgba(111, 140, 255, 0.2), rgba(156, 132, 255, 0.2)) !important;"
                    >
                        <div class="p-2 col-10 text-center md:text-left">
                            <span class="text-xl">Total Amount</span>
                        </div>
                        <div class="p-2 col-2 text-center md:text-right">
                            <span class="text-xl font-medium"
                                >${{ transaction.amount | number:'1.2-2'}}</span
                            >
                        </div>
                    </div>
                </div>
            </div>

            <div class="col pl-0 pb-0 no-print">
                <div class="d-flex justify-content-center">
                    <p-button label="View" (click)="printReceipt(true)"></p-button>
                    <div class="mx-2"></div>
                    <p-button label="Download" (click)="printReceipt(false)"></p-button>
                </div>
            </div>
        </div>
    </div>
</div>
<ng-template #elseBlock>
    <div class="container-fluid">
        <div
            class="card-form"
            style="display: flex; align-items: center; justify-content: center"
        >
            <p-progressSpinner
                [style]="{ width: '45px', height: '37px' }"
                styleClass="custom-spinner"
                strokeWidth="8"
                fill="var(--surface-ground)"
                animationDuration=".9s"
            ></p-progressSpinner>
        </div>
    </div>
</ng-template>
